import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import red from '@material-ui/core/colors/red';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {content_admin} from 'variables/authentication.jsx';

const styles = theme => ({
  card: {
    maxWidth: 400,
    marginBottom: "30px",
    marginTop: "30px",
  },
  star:{
    background:'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  actions: {
    display: 'flex',
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
  button: {
    margin: theme.spacing.unit,
  },
});

class VideoCard extends React.Component {
  state = { expanded: false };

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };



  render() {
    const { classes } = this.props;
    var video_data = this.props.video_data || {}
    var description = "Date posted: 2018-12-12"
    var srcUrl = "https:\/\/i0.wp.com/digital-photography-school.com/wp-content/uploads/2016/06/Rachel-Korinek-Food-Photographer-DPS-Hero-Angle-12.jpg?zoom=2&resize=716%2C478&ssl=1"
    //var thumbnailUrl = "https:\/\/i0.wp.com/digital-photography-school.com/wp-content/uploads/2016/06/Rachel-Korinek-Food-Photographer-DPS-Hero-Angle-12.jpg?zoom=2&resize=716%2C478&ssl=1"
    var subheader = "Created by User"
    var details = "Nobody has ever seen this video."
    
    //if (video_data.thumbnail_url)
    if (video_data.download_url) srcUrl = video_data.download_url;
    if (video_data.created_at) description = "Posted on " + video_data.created_at.split("T")[0];
    if (video_data.username) subheader = "Created by " + video_data.username;
    if (video_data.num_unique_views && video_data.num_unique_views > 0) 
      details = `${video_data.num_unique_views} ${video_data.num_unique_views >= 1?"users have":"user has"} have saw this video; ${video_data.likes == 1?"users have":"user has"} liked it.`

    return (
      <Card className={classes.card}>
        <CardHeader
          color="primary"
          subheader={subheader}
        />
        <video controls height='180' width='100%' controls poster={video_data.thumbnail_url} preload="none">
          <source src={srcUrl}
            type="video/mp4" />
        </video>
        <CardContent>
          <Typography component="p">
            {description}
          </Typography>
        </CardContent>
        <CardActions className={classes.actions} disableActionSpacing>
          
        <Button variant="contained" 
          color="primary" 
          className={video_data.is_krikey_pick? (classes.button, classes.star):classes.button}
          disabled={sessionStorage.getItem('role')!=content_admin}
          onClick={() => {this.props.feature(this.props.video_data)}}
          >
         {video_data.is_krikey_pick? 'Featured': 'Feature'}
        </Button>


          
          <IconButton
            className={classnames(classes.expand, {
              [classes.expandOpen]: this.state.expanded,
            })}
            onClick={this.handleExpandClick}
            aria-expanded={this.state.expanded}
            aria-label="Show more"
          >
            <ExpandMoreIcon />
          </IconButton>
        </CardActions>
        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Typography paragraph>
              {details}
            </Typography>
            {!video_data.download_url? 
            <Typography paragraph>
              Video Unavailable
            </Typography>
              :
            <Link href={video_data.download_url}>
              Download this video
            </Link>  }   
          </CardContent>
        </Collapse>
      </Card>
    );
  }
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(VideoCard);